import dayjs, { Dayjs } from 'dayjs';
import { useSubstitutionStore } from '../components/Substitutions/SubstitutionProvider';
import { useSelectedSchoolYear } from './useSelectedSchoolYear';

/**
 * Zeitraum für Veranstaltungen und Abwesenheiten, immer innerhalb des gewählten Schuljahres:
 * Standard ist heute bis Schuljahresende; ein Start außerhalb des Schuljahres fällt auf dessen
 * Beginn zurück, ein fehlendes oder ungültiges Ende auf dessen Ende.
 */
export function useSubstitutionDateRange(): { from: Dayjs; to: Dayjs } {
  const { rangeStart, rangeEnd } = useSubstitutionStore();
  const schoolYear = useSelectedSchoolYear();

  const schoolYearStart = dayjs(schoolYear?.start).startOf('day');
  const schoolYearEnd = dayjs(schoolYear?.end).startOf('day');

  const from =
    rangeStart && rangeStart.isBetween(schoolYearStart, schoolYearEnd, 'day', '[]') ? rangeStart : schoolYearStart;
  const to = rangeEnd && rangeEnd.isBetween(from, schoolYearEnd, 'day', '[]') ? rangeEnd : schoolYearEnd;

  return { from, to };
}
